import { ArticleHelpfulState } from '@wix/answers-api';
import { Box, Text, ToggleButton } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import {
  ThumbsDownFilledSmall,
  ThumbsDownSmall,
  ThumbsUpFilledSmall,
  ThumbsUpSmall,
} from '@wix/wix-ui-icons-common';
import { FunctionComponent } from 'react';
import { DATA_HOOKS } from '../../../dataHooks';
import css from './index.module.scss';

export type VotingVariationBProps = {
  vote: ArticleHelpfulState;
  onVote: (vote: ArticleHelpfulState) => void;
};

export const VotingVariationB: FunctionComponent<VotingVariationBProps> = ({
  vote,
  onVote,
}: VotingVariationBProps) => {
  const { t } = useTranslation();

  return (
    <Box
      direction="horizontal"
      dataHook={DATA_HOOKS.VOTING_FEEDBACK_BUTTONS}
      className={css.wrapper}
    >
      <Box direction="horizontal" className={css.toggleButtons}>
        <ToggleButton
          as="button"
          dataHook={DATA_HOOKS.HELPFUL_YES}
          shape="pill"
          size='small'
          border={true}
          labelPlacement="end"
          labelValue={
            <Text size="small" weight="normal" className={css.buttonLabel}>
              {t('article-feedback.yes')}
            </Text>
          }
          onClick={() => onVote(ArticleHelpfulState.HELPFUL)}
          selected={vote === ArticleHelpfulState.HELPFUL}
          tooltipProps={{
            placement: 'top',
          }}
        >
          {vote === ArticleHelpfulState.HELPFUL ? (
            <ThumbsUpFilledSmall />
          ) : (
            <ThumbsUpSmall />
          )}
        </ToggleButton>
        <ToggleButton
          as="button"
          dataHook={DATA_HOOKS.HELPFUL_NO}
          shape="pill"
          size='small'
          border={true}
          labelPlacement="end"
          labelValue={
            <Text size="small" weight="normal" className={css.buttonLabel}>
              {t('article-feedback.no')}
            </Text>
          }
          onClick={() => onVote(ArticleHelpfulState.NOT_HELPFUL)}
          selected={vote === ArticleHelpfulState.NOT_HELPFUL}
          tooltipProps={{
            placement: 'top',
          }}
        >
          {vote === ArticleHelpfulState.NOT_HELPFUL ? (
            <ThumbsDownFilledSmall />
          ) : (
            <ThumbsDownSmall />
          )}
        </ToggleButton>
      </Box>
    </Box>
  );
};
